import { api } from "../App";
import { SET_PUBLICATIONS_SUBJECT, SET_PUBLICATIONS_LIST, SET_SINGLE_PUBLICATION, SET_PUBLICATIONS_FORMS, SET_PUBLICATIONS_ADD_AUTHOR, SET_PUBLICATIONS_LOADING, SET_PUBLICATION_FILES } from "./types";


// Отбрасываем пустые/нулевые фильтры (0 = «все»), чтобы не слать их в запрос
const buildParams = (filters = {}) => {
    const params = {};
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== '' && value !== null && value !== undefined && value !== 0) {
            params[key] = value;
        }
    });
    return new URLSearchParams(params).toString();
};


export const getPublications = (filters) => async (dispatch, getState) => {
    try {
        const urlParams = buildParams(filters);
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: true });
        const { data } = await api.get(`/publication?${urlParams}`);
        dispatch({ type: SET_PUBLICATIONS_LIST, payload: { items: data.items, total: data.total } });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: false });
    }
}
export const getSinglePublication = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: true });
        const { data } = await api.get(`/publication/${id}`);
        dispatch({ type: SET_SINGLE_PUBLICATION, payload: data });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: false });
    }
}

export const getPublicationSubject = () => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: true });
        const { data } = await api.get(`/publication/subject`);
        dispatch({ type: SET_PUBLICATIONS_SUBJECT, payload: data.subjects });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: false });
    }
}
// Справочник «Вид публикации» (с пополнением)
export const getPublicationForms = () => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: true });
        const { data } = await api.get(`/publication/form`);
        dispatch({ type: SET_PUBLICATIONS_FORMS, payload: data.forms });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: false });
    }
}
export const getPublicationAddAuthor = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: true });
        const { data } = await api.get(`/publication/add_author`);
        dispatch({ type: SET_PUBLICATIONS_ADD_AUTHOR, payload: data });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: false });
    }
}

// Создание публикации. Возвращает id новой записи (для загрузки отложенных файлов)
export const createPublications = (data, filters) => async (dispatch, getState) => {
    let newId
    try {
        const fil = filters.filters
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: true });
        const { data: res } = await api.post(`/publication`, data);
        newId = res?.id
        await dispatch(getPublications(fil))
    } catch (ERR) {

    } finally {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: false });
        return newId
    }
}
export const updatePublications = (data, filters, id) => async (dispatch, getState) => {
    let success
    try {
        const fil = filters.filters
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: true });
        await api.put(`/publication/${id}`, data);
        await dispatch(getPublications(fil))
        success = true
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: false });
        return success
    }
}

// Удаление публикации (вместе с авторами и файлами — на стороне API)
export const deletePublication = (id, filters) => async (dispatch, getState) => {
    let success
    try {
        const fil = filters?.filters ?? filters
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: true });
        await api.delete(`/publication/${id}`);
        await dispatch(getPublications(fil))
        success = true
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: false });
        return success
    }
}

// Получить список файлов публикации
export const getPublicationFiles = (id) => async (dispatch) => {
    try {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: true });
        const { data } = await api.get(`/publication/${id}/file`);
        dispatch({ type: SET_PUBLICATION_FILES, payload: data });
    } catch (ERR) {
        console.error('Error fetching publication files:', ERR);
    } finally {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: false });
    }
}

// Загрузить файл к публикации
export const uploadPublicationFile = (id, file) => async (dispatch) => {
    let success = false
    try {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: true });
        const formData = new FormData();
        formData.append('file', file);
        await api.post(`/publication/${id}/file`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        await dispatch(getPublicationFiles(id));
        success = true
    } catch (ERR) {
        console.error('Error uploading file:', ERR);
    } finally {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: false });
        return success
    }
}

// Удалить файл публикации
export const deletePublicationFile = (id, fileName) => async (dispatch) => {
    let success = false
    try {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: true });
        await api.delete(`/publication/${id}/file/${fileName}`);
        await dispatch(getPublicationFiles(id));
        success = true
    } catch (ERR) {
        console.error('Error deleting file:', ERR);
    } finally {
        dispatch({ type: SET_PUBLICATIONS_LOADING, payload: false });
        return success
    }
}

// Скачать файл публикации
export const downloadPublicationFile = (id, fileName) => async () => {
    try {
        const response = await api.get(`/publication/${id}/file/${fileName}`, {
            responseType: 'blob'
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (ERR) {
        console.error('Error downloading file:', ERR);
    }
}

// Предпросмотр файла публикации (inline, открывается в новой вкладке)
export const previewPublicationFile = (id, fileName) => async () => {
    try {
        const response = await api.get(`/publication/${id}/file/${fileName}?inline=true`, {
            responseType: 'blob'
        });
        const url = window.URL.createObjectURL(new Blob([response.data], { type: response.data.type }));
        window.open(url, '_blank');
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } catch (ERR) {
        console.error('Error previewing file:', ERR);
    }
}
